import type { Uatraits } from '@yandex-int/k-common';

export const getUatraits = ({ uatraits }: { uatraits: Uatraits }) => uatraits;
